<template>
    <div id="app" :class="$mq">
        <div @click="hideSection" style="width: 48px; height: 48px; text-align: center; position: absolute; right: 0; top: 0;" id="hide-section" :class="$mq">
            <b-icon
                    icon="chevron-down"
                    size="is-large">
            </b-icon>
        </div>

        <div @click="showSection" style="display: none; width: 48px; height: 48px; text-align: center; position: absolute; right: 0; top: -48px; background-color: #ddd;" id="show-section" :class="$mq">
            <b-icon
                    icon="chevron-up"
                    size="is-large">
            </b-icon>
        </div>

        <section class="tab" :class="$mq">
          <h1 class="title">Location</h1>
        <b-field grouped>
            <b-field label="Location from where you want to see the sky" expanded>
                <b-input v-on:keyup.native.enter="getFormValues()" ref="city" placeholder="Search location..."></b-input>
            </b-field>
            <p class="control" style="align-self: flex-end; margin-bottom: .75rem;">
                <button @click.prevent="getFormValues()" class="button is-primary">Search</button>
            </p>
        </b-field>
        </section>

        <section class="tab" :class="$mq">
        <b-field label="Date on which a special event took place">
            <b-datepicker
                    v-model="date"
                    @input="go()"
                    placeholder=""
                    icon="calendar-today"
                    editable>
            </b-datepicker>
        </b-field>
        </section>

        <section class="tab" :class="$mq">
        <h1 class="title">Poster text</h1>
        <b-field label="Title">
            <b-input v-model="title"></b-input>
        </b-field>

        <b-field label="Subtitle">
            <b-input v-model="subtitle"></b-input>
        </b-field>

        <b-field label="Slogan">
            <b-input v-model="tagline"></b-input>
        </b-field>
        </section>

        <section class="tab" :class="$mq">
        <h1 class="title">Colors</h1>

        <div style="display: flex; flex-direction: row; ">
            <div v-for="col in colors.slice(0, 5)" v-bind:key="col" style="padding: 0; margin: 3px; flex: auto; flex-shrink: 1;" >
              <img style="border-radius: 5px; padding: 0; margin: 0; min-width: auto;" src="/static/img/stars.png" @click.prevent="setColor(col)" :style="{ 'background-color': col }" />
            </div>
        </div>
        <div style="display: flex; flex-direction: row; ">
            <div v-for="col in colors.slice(5)" v-bind:key="col" style="padding: 0; margin: 3px; flex: auto; flex-shrink: 1;" >
              <img style="border-radius: 5px; padding: 0; margin: 0; min-width: auto;" src="/static/img/stars.png" @click.prevent="setColor(col)" :style="{ 'background-color': col }" />
            </div>
        </div>
        </section>

        <section class="tab" :class="$mq">
        <h1 class="title">Elements</h1>

        <div class="field">
            <b-switch v-model="milkyway" v-on:input="setMilkyway()" true-value="yes" false-value="no" >
              Milky Way
            </b-switch>
        </div>
        <div class="field">
            <b-switch v-model="grid" v-on:input="setGrid()" true-value="yes" false-value="no">
                Grid
            </b-switch>
        </div>
        <div class="field">
            <b-switch v-model="constellation" v-on:input="setConstellation()" true-value="yes" false-value="no">
              Constellations
            </b-switch>
        </div>
        </section>

        <section class="tab" :class="$mq">
          <h1 class="title">Size</h1>
<!--          <b-field>-->
<!--            <b-radio-button v-model="material"-->
<!--                            native-value="poster"-->
<!--                            >-->
<!--              <span>Poster</span>-->
<!--            </b-radio-button>-->

<!--            <b-radio-button v-model="material"-->
<!--                            native-value="forex"-->
<!--                            >-->
<!--              <span>Forex</span>-->
<!--            </b-radio-button>-->

<!--          </b-field>-->
            <div v-for="size in sizes" v-bind:key="size.name" v-if="size.material === material">
              <div class="field" style="margin-bottom: 4px">
                  <b-radio v-model="format"
                           name="format"
                           :checked="size.name === format"
                           :native-value="size.name">
                    <strong style="width: 100px; display: inline-block">{{ size.name }}</strong> ${{ size.price }}
                  </b-radio>
            </div>
          </div>
        </section>

        <button id="order-desktop" :class="$mq" style="border: none; color: #fff; font-size: 24px; padding: 10px; cursor: pointer; position: fixed; right: 0; bottom: 0; width: 400px; background: green;" @click="addToCart">
            <b-icon icon="cart"></b-icon> Order print
        </button>

        <button id="scroll-down" :class="$mq" style="border-radius: 50%; border: none; color: #fff; font-size: 28px; width: 55px; height: 55px; cursor: pointer; position: fixed; right: 10px; bottom: 70px; background: rgba(0,0,0,0.1);" @click="scrollDown">
            <b-icon icon="chevron-down"></b-icon>
        </button>

        <div id="navigation" :class="$mq">
            <button id="prevBtn" @click.prevent="nextPrev(-1)">Prev</button>
            <button id="nextBtn" @click.prevent="nextPrev(1)">Next</button>
        </div>
        <MountingPortal
                mountTo="#poster_title"
                name="title"
                append
        >
            <span class="poster_title">
            {{ title }}
            </span>
        </MountingPortal>

        <MountingPortal
                mountTo="#poster_subtitle"
                name="subtitle"
                append
        >
            <p>{{ subtitle }}</p>
        </MountingPortal>

        <MountingPortal
                mountTo="#poster_tagline"
                name="tagline"
                append
        >
            <p>{{ tagline }}</p>
        </MountingPortal>

    </div>
</template>

<script>
// Store
import store from './store'

import {Celestial} from '../node_modules/d3-celestial/celestial'
import {MountingPortal} from 'portal-vue'
import BIcon from 'buefy/src/components/icon/Icon'

function ddToDms (lat, lng) {
  let latResult, lngResult, dmsResult

  lat = parseFloat(lat)
  lng = parseFloat(lng)

  latResult = (lat >= 0) ? 'N' : 'S'

  // Call to getDms(lat) function for the coordinates of Latitude in DMS.
  // The result is stored in latResult variable.
  latResult += getDms(lat)

  lngResult = (lng >= 0) ? 'E' : 'W'

  // Call to getDms(lng) function for the coordinates of Longitude in DMS.
  // The result is stored in lngResult variable.
  lngResult += getDms(lng)

  // Joining both variables and separate them with a space.
  dmsResult = latResult + ' ' + lngResult

  // Return the resultant string
  return dmsResult
}

function getDms (val) {
  let valDeg, valMin, valSec, result

  val = Math.abs(val)

  valDeg = Math.floor(val)
  result = valDeg + 'º'

  valMin = Math.floor((val - valDeg) * 60)
  result += ('0' + Math.round(valMin)).slice(-2) + '\''

  valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000
  result += ('0' + Math.round(valSec)).slice(-2) + '"'

  return result
}

let deg2rad = Math.PI / 180

const horizontal = function (dt, pos, loc) {
  // dt: datetime, pos: celestial coordinates [lat,lng], loc: location [lat,lng]
  let ha = getMST(dt, loc[1]) - pos[0]
  if (ha < 0) {
    ha = ha + 360
  }

  ha = ha * deg2rad
  let dec = pos[1] * deg2rad
  let lat = loc[0] * deg2rad

  let alt = Math.asin(Math.sin(dec) * Math.sin(lat) + Math.cos(dec) * Math.cos(lat) * Math.cos(ha))
  let az = Math.acos((Math.sin(dec) - Math.sin(alt) * Math.sin(lat)) / (Math.cos(alt) * Math.cos(lat)))

  if (Math.sin(ha) > 0) {
    az = Math.PI * 2 - az
  }

  return [alt / deg2rad, az / deg2rad, 0]
}

horizontal.inverse = function (dt, hor, loc) {
  var alt = hor[0] * deg2rad
  let az = hor[1] * deg2rad
  let lat = loc[0] * deg2rad
  let dec = Math.asin((Math.sin(alt) * Math.sin(lat)) + (Math.cos(alt) * Math.cos(lat) * Math.cos(az)))
  let ha = ((Math.sin(alt) - (Math.sin(dec) * Math.sin(lat))) / (Math.cos(dec) * Math.cos(lat))).toFixed(6)
  ha = Math.acos(ha)
  ha = ha / deg2rad
  let ra = getMST(dt, loc[1]) - ha
  return [ra, dec / deg2rad, 0]
}

function getMST (dt, lng) {
  let yr = dt.getUTCFullYear()
  let mo = dt.getUTCMonth() + 1
  let dy = dt.getUTCDate()
  let h = dt.getUTCHours()
  let m = dt.getUTCMinutes()
  let s = dt.getUTCSeconds()
  if ((mo === 1) || (mo === 2)) {
    yr = yr - 1
    mo = mo + 12
  }
  let a = Math.floor(yr / 100)
  let b = 2 - a + Math.floor(a / 4)
  let c = Math.floor(365.25 * yr)
  let d = Math.floor(30.6001 * (mo + 1))
  // days since J2000.0
  let jd = b + c + d - 730550.5 + dy + (h + m / 60.0 + s / 3600.0) / 24.0
  // julian centuries since J2000.0
  let jt = jd / 36525.0
  // the mean sidereal time in degrees
  let mst = 280.46061837 + 360.98564736629 * jd + 0.000387933 * jt * jt - jt * jt * jt / 38710000 + lng
  // in degrees modulo 360.0
  if (mst > 0.0) {
    while (mst > 360.0) {
      mst = mst - 360.0
    }
  } else {
    while (mst < 0.0) {
      mst = mst + 360.0
    }
  }
  return mst
}

function parsePlace (place) {
  let location = []

  for (let ac = 0; ac < place.address_components.length; ac++) {
    let component = place.address_components[ac]

    switch (component.types[0]) {
      case 'locality':
        location['city'] = component.long_name
        break
      case 'administrative_area_level_1':
        location['state'] = component.long_name
        break
      case 'country':
        location['country'] = component.long_name
        break
    }
  }


  console.log('location', location)

  return location
}

const font = 'Montserrat'
let kDiff = 8
const kDiffMap = 1

if (document.body.classList.contains('print')) { kDiff = 1 }

var config = {
  width: 0,
  projection: 'airy',
  center: null,
  orientationfixed: true,
  background: {
    fill: '#000000',
    stroke: '#fff',
    opacity: 0
  },
  adaptable: false,
  interactive: false,
  form: false,
  location: false,
  controls: false,
  lang: '',
  container: 'celestial-map', // ID of parent element, e.g. div, null = html-body
  datapath: '/static/data/', // Path/URL to data files, empty = subfolder 'data'
  stars: {
    show: true,
    limit: 7,
    colors: false,
    style: {
      fill: '#ffffff',
      opacity: 1
    },
    names: false,
    proper: false,
    desig: true,
    namelimit: 4,
    namestyle: {
      fill: '#ffffff',
      font: '22px ' + font,
      align: 'left',
      baseline: 'top'
    },
    propernamestyle: {
      fill: '#ffffff',
      font: (30 / kDiff * 2 / kDiffMap) + 'px ' + font,
      align: 'right',
      baseline: 'bottom'
    },
    propernamelimit: 1.5,
    size: 40 / kDiff / kDiffMap,
    exponent: -0.33,
    data: 'stars.6.json'
  },
  dsos: {
    show: false,
    limit: 6,
    names: false,
    desig: false,
    namelimit: 4,
    namestyle: {
      fill: '#cccccc',
      font: '11px ' + font,
      align: 'left',
      baseline: 'top'
    },
    size: null,
    exponent: 1.4,
    data: 'dsos.bright.json',
    symbols: {
      gg: {
        shape: 'circle',
        fill: '#ff0000'
      },
      g: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      s: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      s0: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      sd: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      e: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      i: {
        shape: 'ellipse',
        fill: '#ff0000'
      },
      oc: {
        shape: 'circle',
        fill: '#ffcc00',
        stroke: '#ffcc00',
        width: 1.5
      },
      gc: {
        shape: 'circle',
        fill: '#ff9900'
      },
      en: {
        shape: 'square',
        fill: '#ff00cc'
      },
      bn: {
        shape: 'square',
        fill: '#ff00cc',
        stroke: '#ff00cc',
        width: 2
      },
      sfr: {
        shape: 'square',
        fill: '#cc00ff',
        stroke: '#cc00ff',
        width: 2
      },
      rn: {
        shape: 'square',
        fill: '#00ooff'
      },
      pn: {
        shape: 'diamond',
        fill: '#00cccc'
      },
      snr: {
        shape: 'diamond',
        fill: '#ff00cc'
      },
      dn: {
        shape: 'square',
        fill: '#999999',
        stroke: '#999999',
        width: 2
      },
      pos: {
        shape: 'marker',
        fill: '#cccccc',
        stroke: '#cccccc',
        width: 1.5
      }
    }
  },
  constellations: {
    show: false,
    names: false,
    desig: false,
    lines: false,
    namestyle: {
      fill: '#cccc99',
      align: 'center',
      baseline: 'middle',
      opacity: 0.8,
      font: ['bold 14px ' + font, 'bold 12px ' + font, 'bold 11px ' + font]
    },
    linestyle: {
      stroke: '#fff',
      width: 1 / kDiff * 3 / kDiffMap,
      opacity: 0.6
    },
    bounds: false,
    boundstyle: {
      stroke: '#cccc00',
      width: 0.5,
      opacity: 0.8,
      dash: [2, 4]
    }
  },
  mw: {
    show: false,
    style: {
      fill: '#ffffff',
      opacity: '0.15'
    }
  },
  lines: {
    graticule: {
      show: false,
      stroke: '#fff',
      // width: 1 / kDiff / kDiffMap,
      width: 1 / kDiff * 2 / kDiffMap,
      opacity: 0.8,
      lon: {
        pos: ['center'],
        fill: '#eee',
        font: '0px ' + font
      },
      lat: {
        pos: ['center'],
        fill: '#eee',
        font: '0px ' + font
      }
    },
    equatorial: {
      show: !1,
      stroke: '#aaaaaa',
      width: 1.3,
      opacity: 0.7
    },
    ecliptic: {
      show: !1,
      stroke: '#66cc66',
      width: 1.3,
      opacity: 0.7
    },
    galactic: {
      show: !1,
      stroke: '#cc6666',
      width: 1.3,
      opacity: 0.7
    },
    supergalactic: {
      show: !1,
      stroke: '#cc66cc',
      width: 1.3,
      opacity: 0.7
    }
  }
}

// https://www.w3schools.com/howto/howto_js_form_steps.asp
let currentTab = 0 // Current tab is set to be the first tab (0)

export default {
  name: 'App',
  components: {
    BIcon,
    MountingPortal
  },
  store,
  computed: {
    prices () {
      return store.state.prices
    },
    gridBoolean () {
      return this.grid === 'yes'
    },
    milkywayBoolean () {
      return this.milkyway === 'yes'
    },
    constellationBoolean () {
      return this.constellation === 'yes'
    }
  },
  mounted: function () {
    this.showTab(currentTab)
  },
  beforeCreate: function () {
  },
  created: function () {
    // console.log('title', this.title)
    // console.log('zenith', this.zenith)

    console.log('grid', this.gridBoolean)
    console.log('milkyway', this.milkywayBoolean)
    console.log('constellation', this.constellationBoolean)

    config.background.fill = 'transparent'
    config.background.stroke = 'transparent'
    document.getElementById('celestial-map-bg-color').style.backgroundColor = this.color

    config.constellations.show = this.constellationBoolean
    config.constellations.lines = this.constellationBoolean
    config.lines.graticule.show = this.gridBoolean
    config.mw.show = this.milkywayBoolean

    // config.center = this.zenith
    console.log('zenith', this.zenith)
    let coldStart = true
    if (this.zenith.length >= 3) {
      config.center = this.zenith
      coldStart = false
    }

    Celestial().display(config)

    if (coldStart) {
      this.searchCity('Amsterdam')
    }

    // if (document.body.classList.contains('print')) {
    //   // Fix height of the poster
    //   let size = this.format
    //
    //   let mapcontainerwidth = 620 * 8
    //
    //   let mapRatio = size.height / size.width
    //   let newHeight = mapcontainerwidth * mapRatio
    //
    //   console.log('height', size.height)
    //   console.log('newHeight', mapcontainerwidth * mapRatio)
    //   console.log('format')
    //   document.getElementById('poster').style.height = newHeight + 'px'
    // }

    // Celestial().rotate({center: this.zenith, horizon: false})

    // Celestial().rotate({
    //   center: JSON.parse(JSON.stringify(config.zenith)),
    //   horizon: false
    // })
  },
  data: function () {
    return {
      isLoading: false,
      date: new Date(),
      colors: [
        '#0f1d42',
        '#000000',
        '#333744',
        '#6c6e78',
        '#025D8C',
        '#134a59',
        '#e7304d',
        '#96CFED',
        '#4AD49C',
        '#FF9EB5'
      ],
      format: '18x24inch',
      grid: 'no',
      milkyway: 'yes',
      constellation: 'yes',
      lat: 52.3791,
      lng: 4.8994,
      layout: 1,
      title: this.title || '',
      subtitle: this.subtitle || '',
      tagline: this.tagline || '',
      timezoneOffset: this.timezoneOffset || -120,
      zenith: this.zenith || [],
      color: this.color || '#0f1d42',
      sizes: [
        {
          width: 30,
          height: 40,
          sizePostfix: 'cm',
          name: '30x40cm',
          displayName: 'Small',
          priceEur: 32.95,
          price: 35,
          isActive: false,
          material: 'poster',
          category: 'metric'
        },
        {
          width: 50,
          height: 70,
          sizePostfix: 'cm',
          name: '50x70cm',
          displayName: 'Medium',
          priceEur: 41.95,
          price: 45,
          isActive: false,
          material: 'poster',
          category: 'metric'
        },
        {
          width: 70,
          height: 100,
          sizePostfix: 'cm',
          name: '70x100cm',
          displayName: 'Large',
          priceEur: 54.95,
          price: 59,
          isActive: false,
          material: 'poster',
          category: 'metric'
        },
        {
          width: 11,
          height: 17,
          sizePostfix: 'inch',
          name: '11x17inch',
          displayName: 'Small',
          priceEur: 32.95,
          price: 35,
          isActive: false,
          material: 'poster',
          category: 'imperial'
        },
        {
          width: 18,
          height: 24,
          sizePostfix: 'inch',
          name: '18x24inch',
          displayName: 'Medium',
          priceEur: 41.95,
          price: 45,
          isActive: true,
          material: 'poster',
          category: 'imperial'
        },
        {
          width: 24,
          height: 36,
          sizePostfix: 'inch',
          name: '24x36inch',
          displayName: 'Large',
          priceEur: 54.95,
          price: 59,
          isActive: false,
          material: 'poster',
          category: 'imperial'
        }
        // {key: 'A4', title: 'A4 (€ 24,95)', material: 'poster', width: 210, height: 297},
        // {key: 'A3', title: 'A3 (€ 29,95)', material: 'poster', width: 210, height: 297},
        // {key: 'A2', title: 'A2 (€ 34,95)', material: 'poster', width: 210, height: 297},
        // {key: 'A1', title: 'A1 (€ 39,95)', material: 'poster', width: 210, height: 297},
        // {key: 'A0', title: 'A0 (€ 44,95)', material: 'poster', width: 210, height: 297},
        // {key: '30x40', title: '30x40 cm (€ 49,95)', material: 'forex', width: 300, height: 400},
        // {key: '50x70', title: '50x70 cm (€ 69,95)', material: 'forex', width: 500, height: 700},
        // {key: '60x90', title: '60x90 cm (€ 79,95)', material: 'forex', width: 600, height: 900}
      ],
      material: this.material || 'poster'
    }
  },
  watch: {
    material: function (val) {
      let vue = this
      let format = val === 'forex' ? '30x40' : 'A3'

      setTimeout(function () {
        vue.format = format
      }, 150)
    },
    format: function (val) {
      console.log('format watch')
      let scale = 1
      if (document.body.classList.contains('print')) {
        scale = 8
      }
      let size = this.sizes.find(x => x.name === val)

      let mapcontainerwidth = 620 * scale

      let mapRatio = size.height / size.width
      let newHeight = mapcontainerwidth * mapRatio

      console.log('height', size.height)
      console.log('newHeight', mapcontainerwidth * mapRatio)
      console.log('format')

      document.getElementById('poster').style.height = newHeight + 'px'
    }
  },
  url: {
    material: {
      param: 'material',
      noHistory: true
    },
    zenith: {
      param: 'zenith',
      noHistory: true
    },
    timezoneOffset: {
      param: 'timezoneOffset',
      noHistory: true
    },
    format: {
      param: 'format',
      noHistory: true
    },
    tagline: {
      param: 'tagline',
      noHistory: true
    },
    color: {
      param: 'color',
      noHistory: true
    },
    grid: {
      param: 'grid',
      noHistory: true
    },
    constellation: {
      param: 'constellation',
      noHistory: true
    },
    // layout: {
    //   param: 'layout',
    //   noHistory: true
    // },
    milkyway: {
      param: 'milkyway',
      noHistory: true
    },
    title: {
      param: 'title',
      noHistory: true
    },
    subtitle: {
      param: 'subtitle',
      noHistory: true
    }
  },
  methods: {
    showSection: async function () {
      this.showTab(currentTab)
    },
    addToCart: async function () {
      window.location = 'https://poster.printmycity.com/shoppingcart/add' + window.location.search
    },
    scrollDown: async function () {
      window.scrollBy(0, 250)
    },
    hideSection: async function () {
      const elements = document.getElementsByClassName('tab')
      document.getElementById('show-section').style.display = 'block'
      document.getElementById('hide-section').style.display = 'none'

      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none'
      }
    },
    openLoading: async function () {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 10 * 1000)
    },
    showTab: async function (n) {
      document.getElementById('hide-section').style.display = 'block'
      document.getElementById('show-section').style.display = 'none'
      if (this.$mq !== 'mobile') {
        return
      }

      // This function will display the specified tab of the form...
      const x = document.getElementsByClassName('tab')

      console.log(n)
      console.log(x)

      x[n].style.display = 'block'
      // ... and fix the Previous/Next buttons:
      if (n === 0) {
        document.getElementById('prevBtn').style.display = 'none'
      } else {
        document.getElementById('prevBtn').style.display = 'flex'
      }
      if (n === (x.length - 1)) {
        document.getElementById('nextBtn').innerHTML = 'Bestellen'
      } else {
        document.getElementById('nextBtn').innerHTML = 'Volgende'
      }
      // ... and run a function that will display the correct step indicator:
    },
    nextPrev: async function (n) {
      // This function will figure out which tab to display
      var x = document.getElementsByClassName('tab')
      // Hide the current tab:
      x[currentTab].style.display = 'none'
      // Increase or decrease the current tab by 1:
      currentTab = currentTab + n
      // if you have reached the end of the form...
      if (currentTab >= x.length) {
        // ... the form gets submitted:
        this.addToCart()
        return false
      }
      // Otherwise, display the correct tab:
      this.showTab(currentTab)
    },
    go: async function () {
      console.log('go()')
      console.log('this.subtitle', this.subtitle)

      // position update
      var zone = this.timezoneOffset // todo
      // var date = new Date(date+' 00:00:00');
      // var date = new Date(moment('2018-05-03 00:00:00')._d);
      // var momentDate = moment(date, "DD-MM-YYYY"); // todo

      // eslint-disable-next-line no-undef
      var momentDate = moment(this.date) // todo
      momentDate.hour(0)
      momentDate.minute(0)
      console.log('momentdate', momentDate)
      var date = new Date(momentDate)
      console.log(date)

      var tz = date.getTimezoneOffset()
      var dtc = new Date(date.valueOf() + (zone - tz) * 60000)

      var geopos = [parseFloat(this.lat), parseFloat(this.lng)]
      let zenith = Celestial().getPoint(horizontal.inverse(dtc, [90, 0], geopos), 'equatorial')
      zenith[2] = 0
      config.zenith = zenith

      const app = this
      setTimeout(function () {
        // eslint-disable-next-line no-undef
        app.tagline = moment(date).format('LL')
      }, 100)

      setTimeout(function () {
        app.zenith = zenith
      }, 200)

      console.log('rotate')
      console.log('zenith', zenith)
      console.log('this.zenith', this.zenith)
      console.log('this.subtitle', this.subtitle)

      Celestial().resize()
      Celestial().rotate({
        center: JSON.parse(JSON.stringify(config.zenith)),
        horizon: false
      })
    },
    updateMessage: async function () {
      console.log(this.title)
      this.title = 'updated'
      console.log(this.title)
    },
    setSubtitle: async function (subtitle) {
      this.subtitle = subtitle
    },
    updateSubtitle: async function (subtitle) {
      // console.log(this.safesubtitle)
      // console.log('this.subtitle', this.subtitle)
      // console.log('this.safesubtitle', this.safesubtitle)
      // this.safesubtitle = subtitle

      // setTimeout(this.setSubtitle(subtitle), 500)

      const app = this
      setTimeout(function () {
        // alert('henk')
        app.setSubtitle(subtitle)
      }, 250)

      // console.log('this.subtitle', this.subtitle)
      // console.log('this.safesubtitle', this.safesubtitle)
    },
    setColor: async function (color) {
      console.log(color)
      // update config
      this.color = color

      document.getElementById('celestial-map-bg-color').style.backgroundColor = this.color

      Celestial().resize()
      Celestial().apply({
        background: {
          fill: 'transparent',
          stroke: 'transparent',
          opacity: 0
        }
      })
    },
    setMilkyway: async function () {
      console.log('setMilkyway()')
      Celestial().apply({
        mw: {
          show: this.milkywayBoolean,
          style: {
            fill: '#fff',
            opacity: '0.15'
          }
        }
      })
    },
    setGrid: async function () {
      console.log('setGrid()')
      Celestial().apply({
        lines: {
          graticule: {
            show: this.gridBoolean,
            stroke: '#fff',
            width: 1 / kDiff / kDiffMap,
            opacity: 0.5
          }
        }
      })
    },
    setConstellation: async function () {
      console.log('setConstellation()')
      Celestial().apply({
        constellations: {
          show: this.constellationBoolean,
          lines: this.constellationBoolean
        }
      })
    },
    searchCity: async function (query) {
      console.log('searchCity()')

      fetch('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAgptgbRLVo1bv4Wtzj_Q-z75P7Q8EmOtk&address=' + query)
        .then(response => response.json())
        .then((data) => {
          // sample callback
          console.log(data)
          this.lat = (data.results[0].geometry.location.lat)
          this.lng = (data.results[0].geometry.location.lng)

          console.log(data)

          console.log('fetchMaps()')

          // $('#title').val(ddToDms(lat, lng));

          var location = parsePlace(data.results[0])
          var locationName = location.city
          if (locationName === undefined) locationName = location.state

          // $('#poster_title').html(locationName)
          // $('#poster_subtitle').html(ddToDms(lat, lng))

          this.title = locationName
          this.updateSubtitle(ddToDms(this.lat, this.lng))

          console.log('subtitle')

          // $('#lat').val(lat)
          // $('#lng').val(lng)

          fetch('https://maps.googleapis.com/maps/api/timezone/json?location=' + this.lat + ',' + this.lng +
              '&timestamp=' + (Math.round((new Date().getTime()) / 1000)).toString() +
              '&key=AIzaSyC0dZB10ZI78Jnz3IjOxvFRWEDUkNIDX18')
            .then(response => response.json())
            .then((data) => {
              // sample callback
              console.log(data)

              this.timezoneOffset = data.rawOffset / 60 / -1

              console.log('timezoneOffset', this.timezoneOffset)

              this.go()
            })
        })

      // $.getJSON(
      //   'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAgptgbRLVo1bv4Wtzj_Q-z75P7Q8EmOtk&language=' +
      //     lang + '&address=' + query,
      //   function (data) {
      //   })
    },
    getFormValues () {
      console.log(this.$refs.city)
      this.searchCity(this.$refs.city.newValue)

      // const loadingComponent = this.$loading.open({
      //   container: this.$el // this.isFullPage ? null : this.$refs.element.$el
      // })
      // setTimeout(() => loadingComponent.close(), 3 * 1000)
    }
  }
}
</script>

<style lang="scss">
    @import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";

    // Import Bulma's core
    @import "~bulma/sass/utilities/_all";

    // Set your colors
    $primary: #4099FF;
    $primary-invert: findColorInvert($primary);

    // Setup $colors to use as bulma classes (e.g. 'is-twitter')
    $colors: (
            "white": ($white, $black),
            "black": ($black, $white),
            "light": ($light, $light-invert),
            "dark": ($dark, $dark-invert),
            "primary": ($primary, $primary-invert),
            "info": ($info, $info-invert),
            "success": ($success, $success-invert),
            "warning": ($warning, $warning-invert),
            "danger": ($danger, $danger-invert)
    );

    // Links
    $link: $primary;
    $link-invert: $primary-invert;
    $link-focus-border: $primary;

    // Import Bulma and Buefy styles
    @import "~bulma";
    @import "~buefy/src/scss/buefy";

    #app {
      font-family: "Avenir", Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
      background-color: #ddd;
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999;
    }

    button{
        border: none;
    }

    #app.desktop{
        padding-bottom: 70px;
    }

    #navigation{
        display: flex;
        flex-direction: row;
        flex-flow: row wrap;
        align-items: stretch;
    }

    #nextBtn, #prevBtn {
        text-align: center;
        display: flex;
        flex-grow: 1;
        flex-basis: 0;
        font-size: 20px;
        color: #fff;
        padding: 20px;
        justify-content: center;
    }

    #nextBtn{
        background-color: green;
    }

    #prevBtn{
        background-color: gray;
    }

    .tab {
        padding: 20px;
        display: none;
    }

    .title{
      font-size: 1.5rem;
      margin: 0 0 1rem 0 !important;
    }

    @media screen and (min-width: 450px) {
          #app{
              height: initial;
              width: 400px;
              padding: 25px;
              background-color: #ddd;
              position: absolute;
              top: 0;
              right: 0;
              left: initial;
              bottom: initial;
          }

          .tab {
              display: block !important;
              padding: 0;
          }

        .title{
            font-size: 1.5rem;
            margin: 1rem 0 !important;
        }
    }

    .preview #app{
        display: none !important;
    }

    body.preview{
        background: #FFF !important;
        background-color: #FFF !important;
    }
    html.preview{
        background: #FFF !important;
        background-color: #FFF !important;
    }

    .preview .hidden-preview{
        display: none !important;
    }

    .preview #poster-container{
        margin: 0 !important;
    }

    #hide-section.desktop{
        display: none !important;
    }
    #show-section.desktop{
        display: none !important;
    }
    #navigation.desktop{
        display: none !important;
    }

    #order-desktop.mobile{
        display: none !important;
    }
    #scroll-down.mobile{
        display: none !important;
    }
</style>




// WEBPACK FOOTER //
// src/App.vue